import {useSelector} from 'react-redux';
import {ParkingTypes} from 'common/marketing-metas';

const useMetaDescription = (fallbackDescription, marketingMetasType) => {
    const {
        meta_description: metaDescription,
        'meta-desc': metaDescriptionLegal,
        meta_description_marketing: metaDescriptionMarketing,
        meta_description_transient: metaDescriptionTransient,
        optional_meta_description_transient: optionalMetaDescriptionTransient,
        meta_description_monthly: metaDescriptionMonthly,
        optional_meta_description_monthly: optionalMetaDescriptionMonthly,
    } = useSelector(state => state.page);

    let description = '';

    if (marketingMetasType === ParkingTypes.Transient) {
        description =
            optionalMetaDescriptionTransient || metaDescriptionTransient;
    } else if (marketingMetasType === ParkingTypes.Monthly) {
        description = optionalMetaDescriptionMonthly || metaDescriptionMonthly;
    }

    return (
        description ||
        metaDescription ||
        metaDescriptionLegal ||
        metaDescriptionMarketing ||
        fallbackDescription ||
        'Find, book, and save on parking with convenient garages, lots, and valets near you. Find parking near work, home, airports, and events with the help of SpotHero.'
    );
};

export default useMetaDescription;
